import { useLazyQuery, useMutation } from "@apollo/client/react"; import React, { useMemo, useEffect, useState } from 'react';

import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { TextInput } from '../../../components/textInput/TextInput';
import { useDebounce } from '../../../hooks/useDebounce';
import { ButtonOptionGroup } from '../../../components/buttonOptionGroup/ButtonOptionGroup';
import { PopoverModal } from '../../../components/popoverModal/PopoverModal';
import { useNavigate } from 'react-router-dom';
import { adaptPlanCuidadoArray } from '../../../adapters/planCuidadoAdapter';
import { GET_ALL_PLANES } from '../../../data/graphQL/queries/Planes/getPlanesPaginated';
import { GET_PLANCUIDADO_RENDER_BY_ID } from '../../../data/graphQL/queries/PlanCuidado/getPlanCuidadoById';

import './planCuidadoValidateContent.scss';
import { GET_ALL_ESTADO } from '../../../data/graphQL/queries/PlanCuidado/getEstado';
import { useLocation } from 'react-router-dom';
import CheckIcon from '@mui/icons-material/Check';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { usePersistFilters } from '../../../hooks/usePersistFilters';
import { CHANGE_STATE_PLANCUIDADO } from '../../../data/graphQL/mutations/PlanCuidado/changeStatusPlanCuidado';

export const PlanCuidadoValidateContent = () => {
  const navigate = useNavigate();
  const [estadoPlan, setEstadoPlan] = useState(0);
  const location = useLocation();
  const {
    rows,
    setRows,
    planesLoading,
    totalCount,
    filters,
    handleChangeFilters,
    selectedFilterByStatus
  } = useGetPlanesCuidado();

  const rutasStorage = localStorage.getItem('navigationRoutes');

  const [allowedWrite, setAllowedWrite] = useState(false);

  useEffect(() => {
    if (rutasStorage) {
      const rutas = JSON.parse(rutasStorage);
      const rutaQueSirve = location.pathname;

      setAllowedWrite(rutas?.find((ruta) => ruta.aplicaciones.find((app) => app.url == rutaQueSirve)
      )?.aplicaciones?.find((app) => app.url == rutaQueSirve).escritura);

    }
  }, [rutasStorage]);

  const handleClickAprobarPlanCuidado = async (plan) => {
    changeStatePlanCuidado({
      variables: {
        idPlanCuidado: plan.id,
        state: 'APROBADO'
      }
    });
  };

  const [getPlanes, { data: planesData }] = useLazyQuery(GET_ALL_PLANES, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!planesData) return;
    setRows(planesData);
  }, [planesData])

  const [changeStatePlanCuidado] = useMutation(CHANGE_STATE_PLANCUIDADO, {
    refetchQueries: () => {
      getPlanes({
        variables: {
          // We cast the filter value to boolean because Activo: 0 = false, Inactivo: 1 = true
          where: {
            and: [
              selectedFilterByStatus < 2 ? { activo: { eq: !Boolean(selectedFilterByStatus) } } : {}]

          }
        }
      });
    }
  });

  const handleClickVerPlanCuidado = async (plan) => {
    setEstadoPlan(plan.estado);
    await getRenderPlan({
      variables: {
        IdPlanCuidado: plan.id
      }
    });
  };

  const [getRenderPlan, { data: renderPlan }] = useLazyQuery(GET_PLANCUIDADO_RENDER_BY_ID, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!renderPlan) return;
    renderPlan.planCuidadoToRenderById.insumos = renderPlan.planCuidadoToRenderById?.insumos?.map(obj => {
      const { idInsumoNavigation, ...insumo } = obj
      obj = insumo;
      obj.insumo = { description: idInsumoNavigation?.descripcion, idInsumo: idInsumoNavigation.idInsumo };
      return obj;
    });

    navigate('/validarPlan/previsualizacionPlanCuidado',
      {
        state: {
          Plan: renderPlan.planCuidadoToRenderById,
          AllowedWrite: allowedWrite,
          EstadoPlan: estadoPlan
        }
      });
  }, [renderPlan])

  const [estados, setEstados] = useState([]);

  const initialColumns = [
    {
      headerName: '',
      field: 'action',
      flex: 0.02,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <>
            <PopoverModal>
              <div className='popover-modal-content'>
                {
                  allowedWrite && row.estado == 1 && //solo puede aprobar si tiene permiso y el estado es "en validacion"
                  <div
                    onClick={() => handleClickAprobarPlanCuidado(row)} aria-hidden='true'
                    className='item-option clickable-option'>

                    <CheckIcon className='edit-icon' />
                    <span className='toggle-action'>Aprobar</span>
                  </div>
                }

                <div
                  onClick={() => handleClickVerPlanCuidado(row)} aria-hidden='true'
                  className='item-option clickable-option'>

                  <VisibilityIcon className='edit-icon' />
                  <span className='toggle-action'>Ver</span>
                </div>


              </div>
            </PopoverModal>
          </>);

      }
    },
    {
      field: 'id',
      headerName: '#',
      flex: 0.0370,
      width: 20
    },
    {
      field: 'csPlan',
      headerName: 'Cod. Sap',
      flex: 0.1564,
      width: 110
    },
    {
      field: 'name',
      headerName: 'Nombre',
      flex: 0.1564,
      width: 240
    },
    {
      field: 'tipoModulo',
      headerName: 'Tipo',
      flex: 0.1564,
      width: 190
    },
    {
      field: 'professional',
      type: 'boolean',
      headerName: 'Profesional',
      flex: 0.0864,
      width: 100,
      align: 'center',
      headerAlign: 'center'
    },
    {
      field: 'tm',
      type: 'boolean',
      headerName: 'TM',
      flex: 0.0741,
      width: 80,
      align: 'center',
      headerAlign: 'center'
    },
    {
      field: 'shipment',
      type: 'boolean',
      headerName: 'Envio',
      flex: 0.0741,
      width: 80,
      align: 'center',
      headerAlign: 'center'
    },
    {
      field: 'active',
      type: 'boolean',
      headerName: 'Activo',
      flex: 0.0741,
      width: 80,
      align: 'center',
      headerAlign: 'center'
    },
    {
      field: 'acuerdo',
      type: 'boolean',
      headerName: 'Cliente',
      flex: 0.0741,
      width: 80,
      align: 'center',
      headerAlign: 'center'
    },
    {
      field: 'estado',
      headerName: 'Estado',
      flex: 0.0864,
      width: 100,
      valueGetter: (estado) => {
        return estados?.find((e) => e.idPlanCuidadoEstado === estado)?.nombre;
      }
    }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), [estados]);

  const [getEstados, { loading: estadosLoading, data: estadosData }] = useLazyQuery(GET_ALL_ESTADO, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!estadosData) return;
    setEstados(estadosData?.allPlanCuidadoEstado);
  }, [estadosData]);

  useEffect(() => {
    if (!estadosLoading) {
      getEstados();
    }
  }, []);

  return (
    <div className='assistance-program-container'>
      <div className='action-row'>
        <TextInput
          placeholder='Filtrar'
          value={filters?.searchFilter}
          width='30%'
          searchIcon
          onChange={(e) => handleChangeFilters('searchFilter', e.target.value)}
          onClearButtonClick={() => handleChangeFilters('searchFilter', '')} />

        <div className='button-group-container'>
          <ButtonOptionGroup
            options={['Activos', 'Inactivos', 'Todos']}
            onOptionClick={(v) => handleChangeFilters('selectedFilterByStatus', v)}
            selectedOption={filters?.selectedFilterByStatus} />

        </div>
      </div>
      <DataGridGenerico
        columns={columns}
        rows={rows}
        toolbar={false}
        loading={planesLoading}
        totalCount={totalCount} />

    </div>);

};


const useGetPlanesCuidado = () => {

  const [PlanesCuidado, setPlanesCuidado] = useState([]);

  const { filters, handleChangeFilters } = usePersistFilters(
    {
      searchFilter: '',
      selectedFilterByStatus: 0
    },
    'validarPlanFilters'
  );

  const {
    searchFilter,
    selectedFilterByStatus
  } = filters;

  const debouncedFilterValue = useDebounce(searchFilter, 1000);

  const [getPlanes, { loading: planesLoading, data: planesData }] = useLazyQuery(GET_ALL_PLANES, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!planesData) return;
    setPlanesCuidado(planesData);
  }, [planesData])

  useEffect(() => {
    if (!planesLoading) {
      getPlanes({
        variables: {
          // We cast the filter value to boolean because Activo: 0 = false, Inactivo: 1 = true
          where: {
            or: [
              { nombre: { contains: debouncedFilterValue?.trim() } },
              { idPlanCuidadoEstadoNavigation: { nombre: { contains: debouncedFilterValue?.trim() } } },
              { idPlanCuidado: { eq: parseInt(debouncedFilterValue?.trim()) || 0 } },
              { codigoSap: { contains: debouncedFilterValue?.trim() } },
              {
                idTipoModuloNavigation: {
                  or: [
                    { abreviacion: { contains: debouncedFilterValue?.trim() } },
                    { descripcion: { contains: debouncedFilterValue?.trim() } }]

                }
              }],


            and: [
              selectedFilterByStatus < 2 ? { activo: { eq: !Boolean(selectedFilterByStatus) } } : {}]

          }
        }
      });
    }
  }, [selectedFilterByStatus, debouncedFilterValue]);

  return {
    rows: adaptPlanCuidadoArray(PlanesCuidado) || [],
    setRows: setPlanesCuidado,
    planesLoading,
    totalCount: PlanesCuidado?.allPlanCuidado?.length,
    filters,
    handleChangeFilters,
    selectedFilterByStatus
  };
};